export default __webpack_public_path__ + "static/B30-7e854a4dd0eedc3db4c9f7356651204f.png";